
<div class="maindiv">
    <app-public-header  [company]="company" [branch]="branch"></app-public-header>

    <div class="card , intromain">
        <div class="introsub">
            <div> <img class="paymentProfile"  [src]=" member?.profile ?  config.Server + 'assets/layout/images/company_'+ company+'/branch_'+branch+'/members/'+  member.profile :
                (member?.gender == 'M' ? 'assets/layout/images/avatarBoyImage.png' : 'assets/layout/images/avatarGirlImage.png')"
                onerror="this.src = 'assets/layout/images/avatarBoyImage.png'"
                 [alt]="member?.name" />
            </div>
            <div class="intro">
                <div class="property">{{setLabel("name:Label")}} </div>
                <div class="property">{{setLabel("member#:Label")}} </div>

                <div *ngIf="member?.contactDetail?.contact" class="property">{{setLabel("mobile:Label")}} </div>
                <div *ngIf="member?.email" class="property">{{setLabel("email:Label")}} </div>
                <div *ngIf="member?.gender" class="property">{{setLabel("gender:Label")}} </div>
                <div *ngIf="member?.contactDetail?.address?.street || member?.contactDetail?.address?.city" class="property">{{setLabel("address:Label")}} </div>
            </div>
            <div class="introValue">
                <div class="propertyValue"> {{member?.name}} </div>
                <div class="propertyValue"> {{member?.tagNumber}} </div>

                <div *ngIf="member?.contactDetail?.contact" class="propertyValue"> {{member?.contactDetail?.contact}} </div>
                <div *ngIf="member?.email" class="propertyValue"> {{member?.email}} </div>
                <div *ngIf="member?.gender" class="propertyValue"> {{member?.gender =='M'?'Male':'Female'}} </div>
                <div *ngIf="member?.contactDetail?.address?.street || member?.contactDetail?.address?.city" class="propertyValue"> {{member?.contactDetail?.address?.street ?
                    member?.contactDetail?.address?.street +', ': ''}}
                    {{member?.contactDetail?.address?.city}} </div>
            </div>
        </div>
        <div class="paymentmain">
            <div class="card , cardexpend" [ngClass]="{'card-expanded':active}">
                <h1 class="paymenth1" style=" margin-top: 1px !important;">{{setLabel("feeDetailLabel")}}</h1>
                <div class="iconmain">
                    <a (click)="onClick($event)">
                        <i class="icon" class="material-icons , icon">keyboard_arrow_down</i>
                    </a>
                </div>
            </div>
            <div [@menu]="active ? 'visible' : 'hidden'" style="overflow: hidden;">
                <div *ngIf="!isPaid" class="card , cardhide">

                    <div class="feeMain">
                        <div class="propertyhide">
                            <div>{{setLabel("month:Label")}}</div>
                        </div>
                        <div class="propertyhide1">
                            <div>{{displayMonth}}</div>
                        </div>
                        <div class="propertyhide">
                            <div>{{setLabel("year:Label")}}</div>
                        </div>
                        <div class="propertyhide1">
                            <div>{{year}}</div>
                        </div>
                    </div>
                    <div class="feeMain">
                        <div class="propertyhide">
                            <div>{{setLabel("fee:Label")}}</div>
                        </div>
                        <div class="propertyhide1">
                            <div>{{balance}}</div>
                        </div>
                        <div class="propertyhide">
                            <div>{{setLabel("status:Label")}}</div>
                        </div>
                        <div class="propertyhide1">
                            <div>{{setLabel("unpaidLabel")}}</div>
                        </div>
                    </div>
                </div>
                <div *ngIf="isPaid">
                    <div class="paidMsg">{{paidMsg}}</div>
                    <div *ngFor="let feeDetail of feeDetails" class="card , cardhide">

                        <div class="feeMain">

                            <div class="propertyhide">
                                <div>{{setLabel("invoiceID:Label")}}</div>
                                <div>{{setLabel("month:Label")}}</div>
                                <div>{{setLabel("year:Label")}}</div>
                                <div>{{setLabel("paidDate:Label")}}</div>
                                <div>{{setLabel("amountPaid:Label")}}</div>
                                <div>{{setLabel("status:Label")}}</div>
                            </div>
                            <div class="propertyhide1">
                                <div>{{feeDetail.invoice}}</div>
                                <div>{{feeDetail.month}}</div>
                                <div> {{feeDetail.year}}</div>
                                <div> {{feeDetail.date | date:"mediumDate"}}</div>
                                <div>{{feeDetail.pay | number}}</div>
                                <div>{{feeDetail.status}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="paymentmain">
            <div class="card , paymentCardExpand" [ngClass]="{'card-expanded':payment}">
                <h1 style="margin-top: 1px !important;">{{setLabel("howToPayLabel")}}</h1>
                <div class="icondiv">
                    <a class="icon1" (click)="onPayment($event)"><i class="material-icons">keyboard_arrow_down</i>
                    </a>
                </div>
            </div>
            <div [@menu]="payment ? 'visible' : 'hidden'" style="overflow: hidden;">

                <div *ngFor="let p of selectedBranch?.payments; let i = index" class="card , cardHide1">
                    <div class="bankImage">
                        <img [src]="config.Server + 'assets/layout/images/payments/'+p.logo" width="300" height="100" />
                    </div>
                    <div style="display: flex; justify-content: center;">
                        <div class="accountmain">
                            <div>{{setLabel("accountTitle:Label")}}</div>
                            <div>{{setLabel("a/C#:Label")}}</div>
                            <div *ngIf="p.IBAN">
                                <div>{{setLabel("iBAN#Label")}}</div>
                            </div>
                        </div>
                        <div class="accountNumberMain">
                            <div class="accountTitle"> {{ p.accountTitle}}</div>
                            <div class="accountNumer">{{p.accountNumber}}
                                <span class="copyIcon"><i class="fa fa-copy fa-lg" aria-hidden="true"
                                [ngClass]="{'fa-check': isAccountCopied[i], 'fa-copy': !isAccountCopied[i]}"
                                (click)="copyToClipboard(p.accountNumber, i, 'account')"></i>
                            </span>
                            </div>
                            <div *ngIf="p.IBAN" class="iban">
                                <div>{{p.IBAN}}
                                    <span class="copyIcon"><i class="fa fa-copy fa-lg" aria-hidden="true"
                                        [ngClass]="{'fa-check': isIBANCopied[i], 'fa-copy': !isIBANCopied[i]}"
                                        (click)="copyToClipboard(p.IBAN, i, 'iban')"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="uploadMain">
            <div class="card , receiptCard">
                <h1 style="margin-top: 1px !important;">
                    {{setLabel("uploadFeeReceiptLabel")}}
                </h1>
            </div>
            <div class="card , uploadCard">
                <div class="uploadDivMain">
                    <span class="card, uploadSpan">{{setLabel("invoiceProcessingErrorLabel")}}</span>
                    <div class="uploadSubDiv">
                        <p class="uploadP">{{setLabel("uploadReceiptLabel")}}</p>
                        <input type="file" class="changeEvent" (change)="fileChangeEvent($event)" #receiptPopup
                            hidden />
                        <button  (click)="receiptPopup.click()"
                            class=" selectPhoto p-button  p-widget p-state-default p-corner-all" [disabled]="isSuccess">
                            <span class="ui-button-text ui-c">
                                <i class="fa fa-camera" aria-hidden="true"></i> &nbsp;{{setLabel("selectPhotoBtnLabel")}}
                            </span>
                        </button>
                    </div>
                    <div class="imgDiv">
                        <img style="  width:200px ; height: 200px ;" *ngIf="previewUrl " [src]="previewUrl"
                            alt="Receipt">
                    </div>
                </div>
                <div class="success-message" *ngIf="isSuccess">{{message}}</div>
                <div class="receiptMsg p-message p-message-error" *ngIf="isError">{{message}}</div>
                <div class="submitMain">
                    <input class="submitInput p-button submitButton
                    p-widget
                    p-state-default
                    p-corner-all" [disabled]="!previewUrl" (click)="submit()" type="submit" [value]='setLabel("SubmitValueLabel")' />
                    <div class="p-g-0">
                        <ng-template [ngIf]="isEmailLoader">
                            <div class="ui-g-12">
                                <div class="spinit">
                                    <i class="fa fa-spinner" aria-hidden="true"></i>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-public-footer [branch]="branch"></app-public-footer>
</div>